import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import LoyaltyModal from './loyaltyModal';

const { UI, Customer } = Mobi2Go;

const { requestGetCardStatus } = Customer.DataCandyLoyalty;

const loyaltyModal = (loyalty, cardStatus) => {
    const modal = UI.ExternalModal.create(
        'your-loyalty',
        <LoyaltyModal
            closeModal={() => modal.close()}
            loyaltyScheme={loyalty}
            cardStatus={cardStatus}
        />,
        {
            'data-view': 'your-loyalty',
            className: 'm2g-loyalty-modal',
        }
    );

    modal.mount();
    modal.open();
};

const LoyaltyCTA = ({ loyalty }) => {
    const [t] = useTranslation('order.loyalty');
    const [showButton, setShowButton] = useState(false);
    const [customerLoyalty, setCustomerLoyalty] = useState(null);
    const [cardStatus, setCardStatus] = useState('');

    useEffect(() => {
        updateCustomerState();

        Customer.bind({
            logIn: updateCustomerState,
            update: updateCustomerState,
            updateLoyalty: updateCustomerState,
        });

        return () => {
            Customer.unbind({
                logIn: updateCustomerState,
                update: updateCustomerState,
                updateLoyalty: updateCustomerState,
            });
        };
    }, []);

    useEffect(() => {
        const isDataCandyEnabled = customerLoyalty?.hasOwnProperty(
            'DataCandyLoyalty'
        );

        if (isDataCandyEnabled) {
            setShowButton(
                !!customerLoyalty['DataCandyLoyalty'].state.chosen_card
            );

            if (customerLoyalty['DataCandyLoyalty'].state.chosen_card) {
                try {
                    setCustomerCardStatus(customerLoyalty['DataCandyLoyalty'].state.chosen_card);
                } catch (err) {
                    showErrorMessage();
                    throw err;
                }
            }
        }
    }, [customerLoyalty]);

    const updateCustomerState = async () => {
        await setCustomerLoyalty(Customer.getLoyalty());
    };

    const showErrorMessage = (
        title = 'Error',
        message = 'Something went wrong getting card status'
    ) => {
        UI.centeredAlert({
            title: title,
            body: message,
            temp: true,
            temp_duration: 10000,
        });
    };

    const setCustomerCardStatus = async (cardNumber) => {
      try {
            const cardStatus = await requestGetCardStatus(
                Customer.getEmail(),
                cardNumber
            );

            setCardStatus(cardStatus);
        } catch (err) {
            showErrorMessage();
            throw err;
        }
    };

    return (
        <>
            {showButton && (
                <button
                    className="m2g-button m2g-button--primary m2g-button--add-button m2g-customer-loyalty-button"
                    onClick={() => {
                        loyaltyModal(loyalty, cardStatus);
                    }}
                >
                    {t('customer:loyalty_button')}
                </button>
            )}
        </>
    );
};

LoyaltyCTA.propTypes = {
    loyalty: PropTypes.string,
};

export default LoyaltyCTA;
